var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageTailRight = function SvgMessageTailRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.564.115H0c0 12.638 10.245 22.883 22.882 22.883h9.807v-.538a22.882 22.882 0 0 1-5.678-7.139c-1.835-3.6-2.32-8.02-2.448-15.206Z",
    fill: "currentColor"
  })));
};
export { SvgMessageTailRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzMgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQuNTYzOSAwLjExNTIzNEgwLjAwMDk3NjU2MkMwLjAwMDk3NjU2MiAxMi43NTI4IDEwLjI0NTcgMjIuOTk3NiAyMi44ODMzIDIyLjk5NzZIMzIuNjkwMVYyMi40NjAzQzMwLjM1MDcgMjAuNDk2OSAyOC40MTQyIDE4LjA3MzUgMjcuMDExOCAxNS4zMjExQzI1LjE3NzIgMTEuNzIwNSAyNC42OTIxIDcuMzAxMzIgMjQuNTYzOSAwLjExNTIzNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";